const LogSearchActivityStorageKey = "logSearchActivity";

export function markHeaderSearchForLogging(): void {
    try {
        sessionStorage.setItem(LogSearchActivityStorageKey, "1");
    } catch {
        // sessionStorage unavailable
    }
}

export function consumeHeaderSearchLogMarker(): boolean {
    try {
        const isMarked = sessionStorage.getItem(LogSearchActivityStorageKey) === "1";
        sessionStorage.removeItem(LogSearchActivityStorageKey);
        return isMarked;
    } catch {
        return false;
    }
}
